import moment from "moment";
import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";
import { i18nClient } from "@/i18n";

export default class timeRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("time")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    const date = node.getAttribute("datetime");
    const isShowTime = node.getAttribute("data-isshowtime") === "true";
    const text = isShowTime
      ? moment(+date).format(i18nClient.t("pk_y_d_ts", "YYYY-MM-DD HH:mm:ss"))
      : moment(+date).format(i18nClient.t("pk_y_d", "YYYY-MM-DD"));
    const newNode = document.createElement("span");
    newNode.classList.add(prefixCt("time"));
    newNode.innerHTML = `${text} <span class="icon"></span>`;
    node.parentNode.insertBefore(newNode, node.nextSibling);
    node.parentNode.removeChild(node);
  };
}
